import { ReviewRateGaType } from '../types/review-rate-ga.type';

export class ReviewRateTypeView {
  static REVIEW_OPTION: ReviewRateGaType = 'sat_reviewoption';
  static REVIEW: ReviewRateGaType = 'sat_review';
}
